import React from 'react'

// Material-UI
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import {
  FiPhone,
  FiSmartphone,
  FiUser,
  FiHome
} from "react-icons/fi"
import './WhoOwnsPropertyItem.scss'


function WhoOwnsPropertyItem({ whoOwnsPropertyItem }) {
  return (
    <div className="App WhoOwnsPropertyItem">
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid size={12}>
            <form noValidate autoComplete="off">
              <Grid container>
                <Grid size={12} className="container-field">
                  {whoOwnsPropertyItem.name && (
                    <Grid>
                      {<FiUser />} <label className="main-title-label">Name:</label>
                      <Grid className="container-field">
                        <Grid><label> {whoOwnsPropertyItem.name} </label></Grid>
                      </Grid>
                    </Grid>
                  )}

                  {whoOwnsPropertyItem.cellPhoneNumber && (
                    <Grid>
                      {<FiSmartphone />} <label className="main-title-label">Cell:</label>
                      <Grid className="container-field">
                        <Grid><a href={'tel:' + whoOwnsPropertyItem.cellPhoneNumber}> {whoOwnsPropertyItem.cellPhoneNumber} </a></Grid>
                      </Grid>
                    </Grid>
                  )}

                  {whoOwnsPropertyItem.homePhoneNumber && (
                    <Grid>
                      {<FiPhone />} <label className="main-title-label">Home:</label>
                      <Grid className="container-field">
                        <Grid><a href={'tel:' + whoOwnsPropertyItem.homePhoneNumber}> {whoOwnsPropertyItem.homePhoneNumber} </a></Grid>
                      </Grid>
                    </Grid>
                  )}

                  {whoOwnsPropertyItem.workPhoneNumber && (
                    <Grid>
                      {<FiPhone />} <label className="main-title-label">Work:</label>
                      <Grid className="container-field">
                        <Grid><a href={'tel:' + whoOwnsPropertyItem.workPhoneNumber}> {whoOwnsPropertyItem.workPhoneNumber} </a></Grid>
                      </Grid>
                    </Grid>
                  )}

                  {whoOwnsPropertyItem.livesAtThisLocation && (
                    <Grid>
                      {<FiHome />} <label className="main-title-label">I live here:</label>
                      <Grid className="container-field">
                        <Grid>
                          <label>
                            {whoOwnsPropertyItem.livesAtThisLocation ? "Yes" : "No"}
                          </label>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default WhoOwnsPropertyItem
